import { render, staticRenderFns } from "./userStatistics.vue?vue&type=template&id=0a5ada92&scoped=true&"
import script from "./userStatistics.vue?vue&type=script&lang=ts&"
export * from "./userStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5ada92",
  null
  
)

export default component.exports